import { execApi } from "src/apis/execApi"
import { getFeatureFlags } from "src/aws/customAPI"

type FeatureFlags = {
  useUnreadCountDynamoDBGSI: boolean
}

// メモリキャッシュ（アプリ起動中有効）
let cachedFeatureFlags: FeatureFlags | null = null

/**
 * FeatureFlagを取得（アプリ起動時に1度だけ取得、その後はキャッシュ）
 */
export const fetchFeatureFlags = async (accessToken: string): Promise<FeatureFlags> => {
  if (cachedFeatureFlags) {
    return cachedFeatureFlags
  }

  const result = await execApi(
    () => getFeatureFlags(accessToken),
    (res) => res.getFeatureFlags
  )

  if (result.isOk) {
    cachedFeatureFlags = {
      useUnreadCountDynamoDBGSI: result.content.useUnreadCountDynamoDBGSI ?? false
    }
    console.log('[FeatureFlags] Fetched:', cachedFeatureFlags)
  } else {
    // エラー時はデフォルト値（OpenSearch使用）
    cachedFeatureFlags = {
      useUnreadCountDynamoDBGSI: false
    }
    console.warn('[FeatureFlags] Failed to fetch:', result.error, 'using defaults:', cachedFeatureFlags)
  }

  return cachedFeatureFlags
}

/**
 * キャッシュされたFeatureFlagを取得
 */
export const getCachedFeatureFlags = (): FeatureFlags => {
  return cachedFeatureFlags ?? { useUnreadCountDynamoDBGSI: false }
}

/**
 * キャッシュをクリア（テスト用・開発用）
 */
export const clearFeatureFlagsCache = () => {
  cachedFeatureFlags = null
  console.log('[FeatureFlags] Cache cleared')
}
